export default __webpack_public_path__ + "static/media/Aelfrith's Tribute.5b8263d8.jpg";